import { MemberData } from '@smiles/core-account/dist/Types/GetMember.types';

export const Types = { SET_MEMBER_INFO: 'user/SET_MEMBER_INFO' };

export interface IUserReduxState {
  member?: MemberData;
}

const initialState: IUserReduxState = {
  member: undefined,
};

export default function reducer(state = initialState, action: any = {}): IUserReduxState {
  switch (action.type) {
    case Types.SET_MEMBER_INFO:
      return { ...state, member: action.payload };
    default:
      return state;
  }
}

const setUserInfo = (member: MemberData) => ({
  type: Types.SET_MEMBER_INFO,
  payload: member,
});

export const userActions = { setUserInfo };
